import { toBoolOrNull, toIntOrNull } from '@utils/parse';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import { DashRegistrationStep } from '@/types/dashboard';
import { defaultScreeningProgress } from '@/types/screening/screening-progress';
import type {
    IAssessNutcrackerFormValues,
    IAssessNutcrackerModel,
    IAssessNutcrackerSubmitResult,
} from '@/types/screening/assess-nutcracker';

const ASSESS_NUTCRACKER_ENDPOINT = '/api/register/assess-nutcracker';

const defaultAssessNutcrackerModel: IAssessNutcrackerModel = {
    ...defaultScreeningProgress,
    currentRegistrationStep: DashRegistrationStep.AssessNutcracker,
    hasNutcracker: null,
    wasNutcrackerTreated: null,
    nutcrackerTreatment: '',
};

export const useAssessNutcracker = (registrationId: number, editKey: string) => {
    const url = `${ASSESS_NUTCRACKER_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel(url, defaultAssessNutcrackerModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<
        IAssessNutcrackerFormValues,
        DashRegistrationStep,
        IAssessNutcrackerSubmitResult
    >(
        url,
        (values) => {
            const hasNutcracker = toIntOrNull(values.hasNutcracker);
            const wasNutcrackerTreated = hasNutcracker === 1 ? toBoolOrNull(values.wasNutcrackerTreated) : null;
            const nutcrackerTreatment = wasNutcrackerTreated === true ? values.nutcrackerTreatment : '';

            return {
                hasNutcracker,
                wasNutcrackerTreated,
                nutcrackerTreatment,
            };
        },
        (nextStep) => ({ nextStep }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
